import React, { createContext, FC, useContext } from 'react';
import { NodeInstanceState } from '@glueapp/graph-types';

export const NodeStateContext = createContext<(state: NodeInstanceState) => void>(() => {});

interface NodeStateContextProviderProps {
    setNodeState: (state: NodeInstanceState) => void;
    children: React.ReactNode;
}

export const NodeStateContextProvider: FC<NodeStateContextProviderProps> = props => {
    return <NodeStateContext.Provider value={props.setNodeState}>{props.children}</NodeStateContext.Provider>;
};

export function useNodeState() {
    return useContext(NodeStateContext);
}
